import {
  getApiRequest,
  postApiRequest,
  postFileApiRequest,
  putApiRequest,
  deleteApiRequest
} from '../_helpers';

const path = '/team/'

export const teamService = {
  getAll,
  get,
  post,
  postBulk,
  put,
  remove,
};

function get(id) {
  return getApiRequest(path + id + '/')
}

async function getAll(competition) {
  const params = { competition_id: competition}
  return getApiRequest(path, params)
}

function post(data) {
  return postApiRequest(path, data, {})
}

async function postBulk(data) {
  let file = data.file
  let formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('competition', data.competition);
  return postFileApiRequest(path + 'bulk_upload/', formData, {})
}

function put(id, data) {
  return putApiRequest(path + id + '/', data, {})
}

function remove(id) {
  return deleteApiRequest(path + id + '/')
}

